var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_236_25733"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_236_25733)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3250971,26.571131C13.5514627,29.155329,16.7796345,30.639414,20.174577,30.639484L20.162705000000003,30.628845C22.780431,30.628435,25.190996,29.764515,27.136219,28.308636L30.797314,32.000029L32.000284,30.785774L28.430035,27.184801C30.672525,24.931791,32.011902,21.772527,31.867588,18.317664C31.587173,11.604562300000001,25.817856,6.47849911,19.177463,7.04243144C12.537068399999999,7.60636377,7.69942504,13.6332169,8.536633609999999,20.299032L10.243479,20.080919C10.1914377,19.658233,10.1650076,19.232743,10.164336200000001,18.806815C10.1631742,12.070821800000001,16.581093799999998,7.22346529,22.992054,9.1182387C29.403013,11.0130119,32.20986,18.586768,28.602198,24.256165C24.994532,29.925562,16.9965925,30.509537,12.616443199999999,25.423374L11.3250971,26.571131ZM8,24.471188L9.1976937,25.690763L15.083276699999999,19.791052L19.657727,24.403358L26.957329,16.9981327L25.754358,15.7905273L19.652453,21.970860000000002L15.088552499999999,17.369191999999998L8,24.471188Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/data-icon.2d01a119ac46b44f23acb1ddd0e6de32.svg";
export { ForwardRef as ReactComponent };